<template>
    <v-app>
        <v-layout v-if="messages.isLoading" align-center justify-center row fill-height
                  style="background:rgba(255,255,255,0.53); top:-50px; width: 100%;left:0;position:fixed; z-index:2;">
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </v-layout>
        <v-toolbar dense app color="indigo" dark>
            <v-toolbar-title  class="headline text-uppercase">
                <span>ADAMPHARM</span>
                <span class="font-weight-light">ADMIN</span>
            </v-toolbar-title>
            <v-toolbar-items>
                <v-btn flat to="/">Προσφορές </v-btn>
                <v-btn flat  to="/templates">
                    Επεξεργασια Μυνηματων
                </v-btn>
                <v-btn to="/logs" flat> Kαταγραφές</v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn v-if="storeState.isLoggedIn" @click="refresh" flat> <v-icon> mdi-reload </v-icon></v-btn>
                <v-btn v-if="storeState.isLoggedIn" @click="logout" flat>Αποσυνδεση</v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-content>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>n

<script>
    import StoreState from "@/assets/StoreState";

    export default {
        name: 'App',
        components: {},
        data() {
            return {
                storeState: StoreState.api,
                messages: StoreState.messages
            }
        },
        methods:{
            logout(){
                StoreState.logout()
            },
            refresh(){
                StoreState.messages.isLoading = true;
                StoreState.getB2bData().then(()=>{
                    StoreState.messages.isLoading = false;
                })
            }
        }

    }

</script>



// WEBPACK FOOTER //
// src/App.vue